import cn from 'classnames';
import styles from 'styles/pages/index.module.scss';
import RedPointer from '../../Svgs/redpointer';
import OrangePointer from '../../Svgs/orangepointer';
import GreenPointer from '../../Svgs/greenpointer';

const LineaYTextos = ({ choose_reasons }) => {
  return (
    <>
      <div className="flex sm:flex-col items-start sm:items-center pl-20 sm:pl-0">
        <div
          className={cn(
            styles.gradientLine,
            'relative z-1 w-1 sm:w-[66.5rem] h-250 sm:h-1 sm:mx-auto mb-20 mr-30 sm:mr-auto origin-left large-line-js'
          )}
        >
          <div className="absolute -top-5 left-0 -translate-x-1/2 sm:translate-x-0">
            <div className="pointer-js">
              <RedPointer />
            </div>
          </div>
          <div className="absolute top-1/2 sm:-top-5 left-1/2 -translate-x-1/2">
            <div className="pointer-js">
              <OrangePointer />
            </div>
          </div>
          <div className="absolute bottom-0 right-1/2 sm:-top-5 sm:right-0 translate-x-1/2">
            <div className="pointer-js">
              <GreenPointer />
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-start justify-between">
          <div className="relative -top-10 sm:top-0 sm:-left-60 max-w-[24.2rem] mb-32 sm:mb-0">
            <h4 className="title-6 !font-2 leading-[156%] text-cyan-dark text-left sm:text-center | bottom-text-js">
                {choose_reasons.speed}
            </h4>
          </div>
          <div className="relative -top-10 sm:top-0 max-w-[27rem] mb-32 sm:mb-0">
            <h4 className="title-6 !font-2 leading-[156%] text-cyan-dark text-left sm:text-center | bottom-text-js">
                {choose_reasons.security}
            </h4>
          </div>
          <div className="relative -top-10 sm:top-0 sm:left-75 max-w-[24rem]">
            <h4 className="title-6 !font-2 leading-[156%] text-cyan-dark text-left sm:text-center | bottom-text-js">
                {choose_reasons.quality}
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};
export default LineaYTextos;
